import { render, staticRenderFns } from "./ASelfAssessmentResultPreview.vue?vue&type=template&id=3174c65d&scoped=true&"
import script from "./ASelfAssessmentResultPreview.vue?vue&type=script&lang=ts&"
export * from "./ASelfAssessmentResultPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ASelfAssessmentResultPreview.vue?vue&type=style&index=0&id=3174c65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174c65d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
